import { Icon } from '@chakra-ui/react';

const CustomTemplateIcon = (props) => {
  return (
    <Icon viewBox="0 0 32 42" fill="none" {...props}>
      <rect x="1" y="1" width="29" height="40" rx="4" fill="white" />
      <rect
        x="1"
        y="1"
        width="29"
        height="40"
        rx="4"
        stroke="#3A4A57"
        stroke-width="2"
      />
      <path
        d="M16.7776 33.5533L23.9158 26.4144C24.1978 26.1445 24.5743 25.9958 24.9646 26.0001C25.3549 26.0044 25.7281 26.1613 26.0041 26.4372C26.2801 26.7132 26.4372 27.0863 26.4415 27.4766C26.4459 27.8669 26.2973 28.2434 26.0275 28.5255L18.8881 35.6643C18.7252 35.8272 18.5178 35.9382 18.2919 35.9834L16 36.4419L16.4585 34.1494C16.5037 33.9236 16.6147 33.7161 16.7776 33.5533Z"
        stroke="#3A4A57"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.7085 27.9844L24.4585 29.7344"
        stroke="#3A4A57"
        stroke-width="1.5"
      />
      <line
        x1="2"
        y1="9"
        x2="31.0689"
        y2="9"
        stroke="#3A4A57"
        stroke-width="2"
      />
      <line
        x1="2.03418"
        y1="20"
        x2="31.1031"
        y2="20"
        stroke="#3A4A57"
        stroke-width="2"
      />
    </Icon>
  );
};

export default CustomTemplateIcon;
